// import PageViewer from "@/components/PageViewer";
import PERMISSIONS from "@/common/permissions-lib";

export default {
	path: "ESS",
	props: { pageTransition: "none" },
	component: () => import("@/views/DeviceManager/ESS/Index"),
	children: [
		{
			path: "Diagnostics/:id",
			name: "DeviceManager.ESS.Diagnostics",
			component: () => import("@/views/DeviceManager/ESS/Diagnostics"),
			meta: {
				breadcrumb: "Diagnostics for ESS",
				authorizedRoles: [PERMISSIONS.ESS_DIAGNOSTICS]
			}
		}
	]
};
